export default "__VITE_ASSET__23a39145__"